import styled from 'styled-components';
var AvailabilityResultsWrapper = styled.div.withConfig({
  displayName: "AvailabilityResultsstyles__AvailabilityResultsWrapper",
  componentId: "i6pafh-0"
})(["padding:", ";margin:0;"], function (props) {
  var _props$styles;

  return ((_props$styles = props.styles) === null || _props$styles === void 0 ? void 0 : _props$styles.padding) || '15px';
});
export default AvailabilityResultsWrapper;